var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 508,
    viewBox: "0 0 512 508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2912",
    "data-name": "Rectangle 2912",
    width: 512,
    height: 508,
    transform: "translate(0 0.152)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7995",
    "data-name": "Path 7995",
    d: "M263.925,51.9a6.885,6.885,0,0,0-6.879,6.888V209.439a5.393,5.393,0,0,0,5.388,5.4H472.215a5.4,5.4,0,0,0,5.4-5.4V58.785a6.886,6.886,0,0,0-6.889-6.88Z",
    transform: "translate(-257.046 -51.905)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8046",
    "data-name": "Path 8046",
    d: "M175.586,361.357l37.548,11.475-.011-4.709-37.33-10.466Z",
    transform: "translate(-175.586 -357.657)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -9.681,
    y1: 4.917,
    x2: -9.629,
    y2: 4.917,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aab2c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#858d9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858d9e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8049",
    "data-name": "Path 8049",
    d: "M299.625,313.68,225.4,318.166a3.2,3.2,0,0,0-2.976,2.778L216.2,364.789l80.719-4.879,6.062-42.627a3.2,3.2,0,0,0-3.165-3.609c-.064,0-.128,0-.193.006",
    transform: "translate(-216.202 -313.674)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1.936,
    y1: 2.903,
    x2: -1.926,
    y2: 2.903,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8052",
    "data-name": "Path 8052",
    d: "M433.626,325.666q-3.175,16.042-5.181,32.261a53.579,53.579,0,0,1-7.234-14.538c-.247-.766-1.408-.3-1.162.467a54.7,54.7,0,0,0,7.76,15.353.558.558,0,0,0,.454.247q-.433,3.545-.8,7.1a33.667,33.667,0,0,1-5.369-9.394c-.28-.754-1.443-.289-1.162.467a34.728,34.728,0,0,0,6.1,10.415.624.624,0,0,0,.257.18q-1.2,11.686-1.819,23.424a.619.619,0,0,0-.074.269q-.251,4.3-.3,8.581c-.061,1.865-.115,3.731-.151,5.6a.5.5,0,0,0,.179.423c.323,17.629,2.934,35.066,6.644,52.321.406-.1.811-.189,1.217-.286-4.19-19.5-6.978-39.231-6.613-59.215q.112-3.162.267-6.324a.583.583,0,0,0,.555-.07,20.789,20.789,0,0,0,5.725-5.857c.437-.671-.539-1.457-.979-.782a19.892,19.892,0,0,1-5.238,5.441q1.045-20.209,3.861-40.266l.024,0a.1.1,0,0,0,.029,0c5.465-.827,9.64-4.277,13.654-7.84.6-.531-.144-1.54-.749-1-3.76,3.336-7.677,6.672-12.774,7.54,1.163-8.136,2.517-16.246,4.114-24.314a.58.58,0,0,0-.615-.7.608.608,0,0,0-.623.5",
    transform: "translate(-420.015 -325.162)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -15.477,
    y1: 1.554,
    x2: -15.44,
    y2: 1.554,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8053",
    "data-name": "Path 8053",
    d: "M374.473,354.2c-2.08,1.121-4,10.965-3.759,13.475.1,1.073.239,2.156.4,3.233.057.467.138.935.216,1.4a113.453,113.453,0,0,0,2.983,12.7c.238.153.476.309.732.446,2.679,1.493,8.837,4.243,8.388,4.42a13.6,13.6,0,0,1-7.364.629,47.437,47.437,0,0,0,5.139,10.368c4.033,2.7,13.885,6.724,13.381,6.873a27.842,27.842,0,0,1-6.252,1.047,40.247,40.247,0,0,0,6.877,4.668c5.1,2.773,11.358,4.144,15.2,8.447a.361.361,0,0,0,.3.136.452.452,0,0,0,.786,0c6.36-11.542,3.4-24.2.6-35.556-.132-.539-.264-1.068-.409-1.6a40.172,40.172,0,0,1-6.362,9.343c-.373.4,2.505-11.043,4.014-16.385a23.381,23.381,0,0,0-4.593-7.06c-4.221-4.364-9.888-7.787-15.293-10.861-.219-.128-.457-.24-.677-.368a25.988,25.988,0,0,1-1.542,8.053c-.167.466-1.874-6.827-2.5-10.217-1.31-.653-2.622-1.308-3.956-1.913s-3.009-1.683-4.673-1.683a3.362,3.362,0,0,0-1.638.408",
    transform: "translate(-370.693 -353.795)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -7.224,
    y1: 2.643,
    x2: -7.205,
    y2: 2.643,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8056",
    "data-name": "Path 8056",
    d: "M463.938,378.569c-.56,1.639-2.11,5.363-2.271,5.046a18.5,18.5,0,0,1-1.436-4.149c-1.173.335-2.329.688-3.46,1.117-.072,2.434-.564,7.936-.765,7.509a23.8,23.8,0,0,1-1.935-6.424c-1.2.526-2.373,1.107-3.5,1.736-.336.188-.664.374-.982.563a39.818,39.818,0,0,0-3.509,2.329c-.3.216-.593.45-.885.685a32.1,32.1,0,0,0-3.853,3.548c-.516.555-1,1.127-1.486,1.719-.375,2.915-.941,9.336-1.2,9.07a8.733,8.733,0,0,1-2.085-4.12,29.512,29.512,0,0,0-3.322,9.731c-.72,4.882,2.186,13.445,4.085,18.124a20.98,20.98,0,0,0,1.516,3.294,1.293,1.293,0,0,0,1.3-.558c5.509-7.661,11.015-15.677,17.4-22.627,5.418-5.893,12.568-8.629,19.891-11.341,3.31-1.225,13.733-3.408,13.8-7.913a.674.674,0,0,0,0-.137c-.167-4.856-8.626-7.128-12.218-7.687-.97-.15-1.962-.263-2.963-.332-.308-.031-.628-.044-.947-.056q-1.043-.054-2.1-.054a46.072,46.072,0,0,0-9.066.927",
    transform: "translate(-433.128 -377.642)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -6.807,
    y1: 3.137,
    x2: -6.791,
    y2: 3.137,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_Notification",
    transform: "translate(0 -0.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8776",
    "data-name": "Group 8776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8775",
    "data-name": "Group 8775",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7950",
    "data-name": "Path 7950",
    d: "M1.158,278.013S4.112,369.571,80.542,430.6s182.34,65.4,268.079,71.193S500.214,459.05,510.14,385.681,454.55,290.773,419,207.255,386.621,96.284,311.41,44.917,118.543,25.092,56.855,113.091s-55.7,164.922-55.7,164.922",
    transform: "translate(-0.076 -1.531)",
    fill: "#f1f3f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7951",
    "data-name": "Path 7951",
    d: "M1.158,278.013S4.112,369.571,80.542,430.6s182.34,65.4,268.079,71.193S500.214,459.05,510.14,385.681,454.55,290.773,419,207.255,386.621,96.284,311.41,44.917,118.543,25.092,56.855,113.091,1.158,278.013,1.158,278.013Z",
    transform: "translate(-0.076 -1.531)",
    fill: "none",
    stroke: "#b5bccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7952",
    "data-name": "Path 7952",
    d: "M477.608,58.789V209.442a5.4,5.4,0,0,1-5.389,5.39H262.43a5.4,5.4,0,0,1-5.39-5.39V58.789a6.484,6.484,0,0,1,.319-2.037,6.38,6.38,0,0,1,.509-1.251,7.514,7.514,0,0,1,.742-1.083,6.916,6.916,0,0,1,5.326-2.5h206.8a6.873,6.873,0,0,1,6.875,6.875",
    transform: "translate(-19.487 -3.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7953",
    "data-name": "Path 7953",
    d: "M477.608,58.789V209.442a5.4,5.4,0,0,1-5.389,5.39H262.43a5.4,5.4,0,0,1-5.39-5.39V58.789a6.484,6.484,0,0,1,.319-2.037,6.38,6.38,0,0,1,.509-1.251,7.514,7.514,0,0,1,.742-1.083,6.916,6.916,0,0,1,5.326-2.5h206.8A6.873,6.873,0,0,1,477.608,58.789Z",
    transform: "translate(-19.487 -3.936)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7954",
    "data-name": "Path 7954",
    d: "M477.609,75.619H257.043V58.788a6.885,6.885,0,0,1,6.885-6.885h206.8a6.885,6.885,0,0,1,6.885,6.885Z",
    transform: "translate(-19.487 -3.935)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7955",
    "data-name": "Path 7955",
    d: "M298.092,64.435a3.642,3.642,0,1,1,3.641,3.642,3.641,3.641,0,0,1-3.641-3.642",
    transform: "translate(-22.599 -4.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7956",
    "data-name": "Path 7956",
    d: "M298.092,64.435a3.642,3.642,0,1,1,3.641,3.642A3.641,3.641,0,0,1,298.092,64.435Z",
    transform: "translate(-22.599 -4.609)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7957",
    "data-name": "Path 7957",
    d: "M282.926,64.435a3.643,3.643,0,1,1,3.642,3.642,3.642,3.642,0,0,1-3.642-3.642",
    transform: "translate(-21.449 -4.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7958",
    "data-name": "Path 7958",
    d: "M282.926,64.435a3.643,3.643,0,1,1,3.642,3.642A3.642,3.642,0,0,1,282.926,64.435Z",
    transform: "translate(-21.449 -4.609)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7959",
    "data-name": "Path 7959",
    d: "M271.36,68.564a4.173,4.173,0,1,1,4.174-4.173,4.178,4.178,0,0,1-4.174,4.173",
    transform: "translate(-20.256 -4.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 4.173,
    cy: 4.173,
    r: 4.173,
    transform: "translate(246.915 63.983) rotate(-89.783)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7960",
    "data-name": "Path 7960",
    d: "M481.239,66.772l-2.576,2.576-2.553-2.554,2.575-2.575-2.575-2.576,2.553-2.553,2.576,2.575,2.575-2.575,2.554,2.553-2.575,2.576,2.575,2.575-2.554,2.554Z",
    transform: "translate(-36.095 -4.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7961",
    "data-name": "Path 7961",
    d: "M483.754,58.278l-.75.75-1.825,1.825-1.826-1.825-.75-.75-.75.75-1.8,1.8-.75.75.75.75,1.825,1.826-1.825,1.824-.75.75.75.75,1.8,1.8.75.75.75-.75,1.826-1.826L483,69.285l.75.75.75-.75,1.8-1.8.75-.75-.75-.75-1.825-1.824,1.825-1.826.75-.75-.75-.75-1.8-1.8Z",
    transform: "translate(-36.034 -4.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7962",
    "data-name": "Path 7962",
    d: "M483.754,58.278l-.75.75-1.825,1.825-1.826-1.825-.75-.75-.75.75-1.8,1.8-.75.75.75.75,1.825,1.826-1.825,1.824-.75.75.75.75,1.8,1.8.75.75.75-.75,1.826-1.826L483,69.285l.75.75.75-.75,1.8-1.8.75-.75-.75-.75-1.825-1.824,1.825-1.826.75-.75-.75-.75-1.8-1.8Z",
    transform: "translate(-36.034 -4.418)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7963",
    "data-name": "Path 7963",
    d: "M489.93,140.914H421.373a1.214,1.214,0,0,1-1.358-.17.917.917,0,0,1,.572-1.7h.106a19.818,19.818,0,0,1,16.784-2.95c-.552-1.549-1.422-3.013-.658-4.689.806-1.7,2.949-2.695,4.859-3.162a12.391,12.391,0,0,1,9.909,1.444,9.855,9.855,0,0,1,10.058-7.406,9.543,9.543,0,0,1,9.314,8.976,17.225,17.225,0,0,1,8.807-.106c2.419.722,3.077,2.865,4.859,3.566,1.7.657,3.586.042,5.3.318Z",
    transform: "translate(-31.809 -9.27)",
    fill: "#f1f3f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7964",
    "data-name": "Path 7964",
    d: "M489.93,140.914H421.373a1.214,1.214,0,0,1-1.358-.17.917.917,0,0,1,.572-1.7h.106a19.818,19.818,0,0,1,16.784-2.95c-.552-1.549-1.422-3.013-.658-4.689.806-1.7,2.949-2.695,4.859-3.162a12.391,12.391,0,0,1,9.909,1.444,9.855,9.855,0,0,1,10.058-7.406,9.543,9.543,0,0,1,9.314,8.976,17.225,17.225,0,0,1,8.807-.106c2.419.722,3.077,2.865,4.859,3.566,1.7.657,3.586.042,5.3.318Z",
    transform: "translate(-31.809 -9.27)",
    fill: "none",
    stroke: "#b5bccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7965",
    "data-name": "Path 7965",
    d: "M299.923,143.346a.894.894,0,0,1-.976.128H257.04v-7.151a12.431,12.431,0,0,1,6.047.17A6.859,6.859,0,0,1,269.814,130a7.121,7.121,0,0,1,7.277,5.347,9.006,9.006,0,0,1,7.173-1.04c1.379.34,2.928,1.061,3.5,2.292.573,1.21-.064,2.27-.467,3.4a14.315,14.315,0,0,1,12.158,2.122h.064a.662.662,0,0,1,.4,1.23",
    transform: "translate(-19.487 -9.855)",
    fill: "#f1f3f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7966",
    "data-name": "Path 7966",
    d: "M299.923,143.346a.894.894,0,0,1-.976.128H257.04v-7.151a12.431,12.431,0,0,1,6.047.17A6.859,6.859,0,0,1,269.814,130a7.121,7.121,0,0,1,7.277,5.347,9.006,9.006,0,0,1,7.173-1.04c1.379.34,2.928,1.061,3.5,2.292.573,1.21-.064,2.27-.467,3.4a14.315,14.315,0,0,1,12.158,2.122h.064A.662.662,0,0,1,299.923,143.346Z",
    transform: "translate(-19.487 -9.855)",
    fill: "none",
    stroke: "#b5bccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7967",
    "data-name": "Path 7967",
    d: "M307.329,103.839h.118a26.781,26.781,0,0,1,22.686-3.972c-.747-2.108-1.933-4.083-.886-6.333,1.067-2.3,3.98-3.638,6.538-4.266,4.68-1.152,9.719-.605,13.38,1.932a13.343,13.343,0,0,1,13.6-10,12.872,12.872,0,0,1,12.572,12.123c3.842-.923,8.092-1.295,11.883-.157,3.276.983,4.163,3.874,6.581,4.811,3.278,1.267,7.059-.962,9.96,1.764a3.569,3.569,0,0,1,1.135,3.9,8.833,8.833,0,0,1-2.652,2.717H308.384a1.62,1.62,0,0,1-1.83-.219,1.245,1.245,0,0,1,.775-2.3",
    transform: "translate(-23.195 -6.155)",
    fill: "#f1f3f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7968",
    "data-name": "Path 7968",
    d: "M307.329,103.839h.118a26.781,26.781,0,0,1,22.686-3.972c-.747-2.108-1.933-4.083-.886-6.333,1.067-2.3,3.98-3.638,6.538-4.266,4.68-1.152,9.719-.605,13.38,1.932a13.343,13.343,0,0,1,13.6-10,12.872,12.872,0,0,1,12.572,12.123c3.842-.923,8.092-1.295,11.883-.157,3.276.983,4.163,3.874,6.581,4.811,3.278,1.267,7.059-.962,9.96,1.764a3.569,3.569,0,0,1,1.135,3.9,8.833,8.833,0,0,1-2.652,2.717H308.384a1.62,1.62,0,0,1-1.83-.219A1.245,1.245,0,0,1,307.329,103.839Z",
    transform: "translate(-23.195 -6.155)",
    fill: "none",
    stroke: "#b5bccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8778",
    "data-name": "Group 8778",
    transform: "translate(237.559 47.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8777",
    "data-name": "Group 8777",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7969",
    "data-name": "Path 7969",
    d: "M368.518,186.613c.053.263.119.554.186.842a54.111,54.111,0,0,1,.887,5.349c.115,1.363.211,2.768.3,4.235.01.872.031,1.769-.014,2.657-.147,8.6-3.108,29.928-18.279,35.01-12.509,4.191-58.911,1.38-68.618-3.693-3.209-1.69,6.078-6.943,6.078-6.943.222-.3,2.381-.986,5.707-1.91,12.437-3.491,43.981-11.941,44.438-14.027.314-1.57-1.932-7.9-4.956-16.276l-.048-.14c-.195-.494-.355-1.066-.544-1.627-.319-.861-.639-1.72-.959-2.674-.016-.055-.018-.151-.063-.2-5.986-16.929-8.883-31.262-5.955-41.79,2.913-10.4,28.086,19.307,28.086,19.307a42.121,42.121,0,0,1,6.818,6.386c3.619,4.091,5.26,8.065,6.94,15.488",
    transform: "translate(-258.961 -58.828)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7970",
    "data-name": "Path 7970",
    d: "M375.44,193.049c-.65-4.494-.629-10.361-.862-15.831-.1-2.081-.23-4.113-.421-5.968a24.7,24.7,0,0,0-1.489-6.71,7.183,7.183,0,0,0-1.252-2.152,110.5,110.5,0,0,0-9.767-8.3c-12.952-10.1-30.985-16.868-33.776-9.53-4.785,12.571.113,27.963,4.294,44.56,10.613,8.689,26.579,12.275,43.273,3.927",
    transform: "translate(-262.266 -58.696)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7971",
    "data-name": "Path 7971",
    d: "M281.52,229.184c-5.041,1.911-11.537,6.817-11.929,12.806-.188,2.883,1.679,3.046,2.91.7,2.37-4.511,5.385-6.889,1.444-.377-.8,1.316-1.789,4.419-.807,5.011,2.088,1.258,4.31-3.793,5.579-5.868,1.824-1.083-.36,4.266-.118,5.407,1.092,5.158,5.414-4.706,6.188-4.711,2.178-.013-1.79,6.187,1.53,5.088,2.492-.823,3.72-7.921,5.14-9.633,1.165-1.4,2.925-1.556,2.654-3.654-.6-4.683-10.464-5.582-12.592-4.774",
    transform: "translate(-257.996 -65.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7972",
    "data-name": "Path 7972",
    d: "M279.6,248.85a1.193,1.193,0,0,1-.214-.019c-.984-.173-1.259-1.469-1.348-1.9a7.582,7.582,0,0,1,.395-2.648,19.8,19.8,0,0,0,.438-2.153c-.146.252-.3.531-.463.825-1.126,2.03-2.527,4.558-4.142,4.99a1.806,1.806,0,0,1-1.444-.209,1.344,1.344,0,0,1-.594-.874c-.321-1.3.519-3.705,1.223-4.866.229-.379.43-.719.6-1.024-.364.559-.75,1.206-1.126,1.922-.737,1.4-1.759,2.113-2.676,1.854-.419-.117-1.377-.63-1.233-2.839.423-6.482,7.57-11.487,12.27-13.268,1.652-.627,7.3-.343,10.683,1.688a4.875,4.875,0,0,1,2.624,3.514,2.969,2.969,0,0,1-1.617,3.057,6.117,6.117,0,0,0-1.155,1,14.781,14.781,0,0,0-1.511,3.447c-.972,2.7-2.072,5.756-3.87,6.35a1.724,1.724,0,0,1-1.674-.137c-.657-.594-.4-1.757-.125-2.988a5.068,5.068,0,0,0,.218-1.908,18.834,18.834,0,0,0-1.122,1.689c-1.627,2.613-2.9,4.488-4.141,4.488m-.515-8.106a.773.773,0,0,1,.47.152c.636.469.393,1.629-.091,3.639a9.646,9.646,0,0,0-.389,2.18c.171.808.4,1.053.494,1.07.713.12,2.5-2.755,3.271-3.985,1.07-1.719,1.4-2.214,1.9-2.217h.009a1.133,1.133,0,0,1,.925.407c.5.615.257,1.687,0,2.822-.129.58-.4,1.789-.2,1.969,0,0,.137.078.628-.084,1.307-.432,2.359-3.354,3.205-5.7a14.627,14.627,0,0,1,1.693-3.765,6.98,6.98,0,0,1,1.347-1.183c.83-.6,1.332-.969,1.189-2.066a3.881,3.881,0,0,0-2.117-2.739c-3.132-1.879-8.467-2.1-9.76-1.606-4.443,1.685-11.195,6.362-11.587,12.344-.071,1.092.19,1.673.462,1.749.247.072.87-.226,1.448-1.326.633-1.2,2.673-4.648,3.711-4.669a.634.634,0,0,1,.549.308c.163.281.408.706-1.891,4.505a7.578,7.578,0,0,0-1.1,4.064.37.37,0,0,0,.111.218.757.757,0,0,0,.623.093c1.179-.316,2.568-2.822,3.488-4.48.273-.492.522-.942.744-1.3l.068-.112.113-.067a1.344,1.344,0,0,1,.68-.218",
    transform: "translate(-257.953 -65.282)",
    fill: "#034f9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7973",
    "data-name": "Path 7973",
    d: "M284.182,228.867c-2.051-.347-7.081-1.157-9.064-.26-1.083.491-2.115,1.687-.548,2.351a6.544,6.544,0,0,0,3.224.183c.9-.12,1.9.013,2.768-.176.892-.194,3.89-2.052,3.62-2.1",
    transform: "translate(-258.314 -65.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7974",
    "data-name": "Path 7974",
    d: "M276.282,231.742a5.077,5.077,0,0,1-1.962-.338c-.92-.39-1.12-.955-1.125-1.36-.01-.831.827-1.584,1.662-1.962,1.477-.67,4.542-.6,9.37.22h0l.43.075.028.452c.016.791-3.711,2.538-4.055,2.613a8.094,8.094,0,0,1-1.649.128,9.682,9.682,0,0,0-1.162.055,11.54,11.54,0,0,1-1.539.118m1.53-3.059a6.493,6.493,0,0,0-2.517.364c-.616.279-1.042.742-1.039.983,0,.122.18.271.479.4a5.864,5.864,0,0,0,2.944.145,10.32,10.32,0,0,1,1.294-.066,7.218,7.218,0,0,0,1.433-.1,12.63,12.63,0,0,0,2.431-1.252,34.868,34.868,0,0,0-5.025-.469",
    transform: "translate(-258.27 -65.227)",
    fill: "#034f9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7975",
    "data-name": "Path 7975",
    d: "M297.918,228.37l-7.862,2.184a36.739,36.739,0,0,0-7.93-1.411c-2.989.023-3.992,1.065-3.992,1.065s.849,1-.463,1.89,11.3,6.982,12.77,7.138,6.057,1.118,6.057,1.118,3.781-5.656,3.781-5.992-2.361-5.992-2.361-5.992",
    transform: "translate(-258.602 -65.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7976",
    "data-name": "Path 7976",
    d: "M343.214,177.322l7.029,22.278a32.805,32.805,0,0,0,11.221.728c6.327-.661-13.425-25.2-13.425-25.2Z",
    transform: "translate(-263.579 -61.247)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7977",
    "data-name": "Path 7977",
    d: "M391.116,465.54c1.207-1.508,14.257-.249,14.39.537.4,2.4,1.02,11.606-.227,12.822-1.208,1.181-12.479,3.749-12.733,1.418-.219-2.013-2.6-13.321-1.429-14.777",
    transform: "translate(-267.186 -83.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7978",
    "data-name": "Path 7978",
    d: "M394.99,481.735a6.093,6.093,0,0,1-1.947-.245,1.4,1.4,0,0,1-1.067-1.159c-.05-.448-.215-1.4-.423-2.613-1.259-7.295-1.774-11.455-.895-12.553,1.342-1.676,11.872-.594,14.172,0,.542.14,1.078.316,1.155.777.263,1.588,1.2,11.746-.382,13.292-1,.982-7.02,2.5-10.613,2.5M391.071,465.5l.414.332c-.748.933.6,8.762,1.112,11.71.212,1.226.379,2.2.431,2.678.016.128.239.226.372.274,2.368.851,10.605-1.176,11.463-2.015.877-.854.625-8.811.107-12.168-1.687-.807-12.614-1.515-13.484-.48Z",
    transform: "translate(-267.142 -83.167)",
    fill: "#034f9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7979",
    "data-name": "Path 7979",
    d: "M404.247,477.015s6.034,8.627,1.721,15.406c0,0-31.425,1.48-40.917,0,0,0-.245-11.586,7.888-12.57a148.562,148.562,0,0,1,17.3-.847s8.105,4.419,14.012-1.99",
    transform: "translate(-265.234 -84.134)",
    fill: "#000a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7980",
    "data-name": "Path 7980",
    d: "M403.523,336.161c-1.48,18.486-.122,55.758,1.357,74.244.09,1.242.093,44.185.093,44.185L387.6,456.25c-9.456-28.22-27.52-91.517-27.52-119.615s2.422-74.92,12.746-97.131c9.818-21.118,48.548,8.05,53.1,13.225,2.1,2.4-1.877,23.775-7.377,37.942-6.39,16.415-14.229,35.553-15.025,45.489",
    transform: "translate(-264.857 -65.553)",
    fill: "#000a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7981",
    "data-name": "Path 7981",
    d: "M407.886,412.767c-1.015-18.517-4.071-55.636-2.591-74.123.8-9.937,12.844-38.592,19.233-55.006-1.684-5.059.42-15.922-3.751-18.73-3.461-2.307-16.99,12.987-18.5,17.511-1.214,3.578,1,8.105,1.271,11.683a33.516,33.516,0,0,1-4.319,18.751c-4.791,8.491-10.677,15.173-13.37,24.786-5.205,18.7-1.033,38.185,3.346,56.581,2.778,11.6,5.736,23.279,6.447,35.228.384,6.863,1.346,21.909.369,28.651l10.722-1.027s2.149-25.871,1.141-44.3",
    transform: "translate(-266.628 -68.035)",
    fill: "#000a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7982",
    "data-name": "Path 7982",
    d: "M476.86,455.821c.778-1.77,13.714-3.927,14.043-3.2,1.006,2.216,3.5,10.752,3.093,12.449-.993,4.148-14.509,10.271-15.355,8.087-.734-1.89-2.529-15.626-1.781-17.332",
    transform: "translate(-273.697 -82.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7983",
    "data-name": "Path 7983",
    d: "M479.686,474.1c-.847,0-1.377-.267-1.582-.8-.721-1.854-2.623-15.8-1.772-17.736.867-1.973,11.328-3.648,13.7-3.663.567-.012,1.112.029,1.306.454.908,2,3.605,10.8,3.127,12.793-.924,3.86-10.74,8.687-14.478,8.94-.105.007-.208.01-.3.01M477.3,455.992c-.605,1.388.972,14.819,1.79,16.926.009.027.206.152.827.112,3.6-.243,12.782-5.057,13.517-8.13.348-1.443-1.927-9.461-2.983-11.931-1.844-.342-12.578,1.8-13.151,3.024",
    transform: "translate(-273.654 -82.23)",
    fill: "#034f9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7984",
    "data-name": "Path 7984",
    d: "M415.086,246.532c.677,11.4,10.481,58.612,16.953,101.768,4.174,27.786,22.324,75.821,40.81,98.819l14.19-3.639,3.184-.792s-7.928-30.823-12.12-43.02c-10.94-31.668-3.943-51.233-4.7-69.764-1.615-38.15,7.645-57.13-3.785-85.131-.523-1.283-1.1-2.593-1.713-3.9a119.7,119.7,0,0,0-8.321-14.914,3.866,3.866,0,0,0-2.275-1.544,9.773,9.773,0,0,0-4.268-.114c-7.208,1.12-38.048,20.405-37.954,22.234",
    transform: "translate(-269.027 -64.961)",
    fill: "#000a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7985",
    "data-name": "Path 7985",
    d: "M468.384,354.052c3.968,15.633-.114,35.4,3.212,51.222,3,14.061,11.329,28.041,19.2,39.9l3.185-.792s-7.929-30.823-12.121-43.02c-10.939-31.668-3.943-51.233-4.7-69.765-1.615-38.15,7.645-57.129-3.785-85.131-2.816.756-5.5,1.8-7.516,2.523a1.071,1.071,0,0,0-.662.555,1.116,1.116,0,0,0-.45,1.408c6.1,18.131,4.681,35.406,1.8,53.949-2.59,16.844-2.4,32.583,1.835,49.152",
    transform: "translate(-272.786 -66.655)",
    fill: "#000a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7986",
    "data-name": "Path 7986",
    d: "M492.4,464.734s7.047,8.566,3.1,17.59c0,0-32.809,9.681-42.876,10.353,0,0-1.233-13.492,7.209-16.7a122.716,122.716,0,0,1,16.995-4.938s9.923,2.692,15.575-6.3",
    transform: "translate(-271.868 -83.203)",
    fill: "#000a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7987",
    "data-name": "Path 7987",
    d: "M465.05,230.085c.318,2.621-7.508,9.462-20.455,15.168a103.4,103.4,0,0,1-26.023,7.554c-21.211,3.239-51.421-3.194-53.791-5.215-4.081-9.941,3.7-34.931-3.32-47.989-2.225-4.124-6.819-10.085-11.77-16.671-10.7-14.2-22.919-29.584-22.2-40.257,10.119-13,39.288-27.77,59.8-28.317a19.681,19.681,0,0,1,8.954,1.342,12.588,12.588,0,0,1,1.627.956,47.13,47.13,0,0,1,7.023,6.556c7.975,8.724,18.722,23.635,27.858,39.271,11.012,18.865,31.834,63.9,32.295,67.6",
    transform: "translate(-262.384 -56.638)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7988",
    "data-name": "Path 7988",
    d: "M400.943,120.731c-8.85-1.318-19.765,14.2-21.306,21.122-3.391,15.21-1.788,32.705-.334,35.857q1.483.168,2.958.269c.968,12.469-3.379,36.151-5.81,40.083-.447.732-4.246,3.411-9.244,6.743-.53,8.86-1.447,17.4.274,22.549,10.284-2.8,22.26-7.321,29.993-14.4a22.947,22.947,0,0,0,4.257-6.177c3.016-5.784,6.072-14.441,8.512-23.7.254-.994.521-1.962.734-2.965q.929-3.685,1.654-7.357a120.3,120.3,0,0,0,2.679-22.522,40.244,40.244,0,0,0,5.991-4.844c-6.369-18.961-6.181-42.541-20.358-44.65",
    transform: "translate(-265.343 -57.117)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7989",
    "data-name": "Path 7989",
    d: "M341.848,123.792l3.536,4.513s-1.295,5.343.986,5.208c7.756-.453,10.179-10.977,10.179-10.977l-8.907-10.424Z",
    transform: "translate(-263.475 -56.469)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7990",
    "data-name": "Path 7990",
    d: "M322.122,106.041a60.373,60.373,0,0,0,6.933,15.237c3.318,5,17,5.255,18.179-6.893S338.126,94.2,338.126,94.2Z",
    transform: "translate(-261.98 -55.111)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7991",
    "data-name": "Path 7991",
    d: "M347.388,100c.007-.083-.181-.379-.321-.763A6.161,6.161,0,0,0,342,95.34a1.62,1.62,0,0,0-1.778,1.3c-.021.015-.043.018-.066.034-2.028,1.517-.013,3.83.835,5.328,1.421,2.517,2.332,6.226,4.923,7.852a3.624,3.624,0,0,0,5.094-1.03c1.368-2.144-.317-3.683-.921-5.632a4.279,4.279,0,0,0-1.652-2.737,5.213,5.213,0,0,0-1.052-.462",
    transform: "translate(-263.281 -55.197)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7992",
    "data-name": "Path 7992",
    d: "M347.388,100c.007-.083-.181-.379-.321-.763A6.161,6.161,0,0,0,342,95.34a1.62,1.62,0,0,0-1.778,1.3c-.021.015-.043.018-.066.034-2.028,1.517-.013,3.83.835,5.328,1.421,2.517,2.332,6.226,4.923,7.852a3.624,3.624,0,0,0,5.094-1.03c1.368-2.144-.317-3.683-.921-5.632a4.279,4.279,0,0,0-1.652-2.737A5.213,5.213,0,0,0,347.388,100Z",
    transform: "translate(-263.281 -55.197)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7993",
    "data-name": "Path 7993",
    d: "M314.191,104.186c-.4,3.68,3.886,6.948,6.753,6.987,8.442.114,9.281-5.882,12.007-6.62,4.008-1.087,10.468-.648,8.639-6.819-3.1-10.462-26.5-1.749-27.4,6.452",
    transform: "translate(-261.376 -55.015)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7994",
    "data-name": "Path 7994",
    d: "M314.191,104.186c-.4,3.68,3.886,6.948,6.753,6.987,8.442.114,9.281-5.882,12.007-6.62,4.008-1.087,10.468-.648,8.639-6.819C338.491,87.272,315.093,95.985,314.191,104.186Z",
    transform: "translate(-261.376 -55.015)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8780",
    "data-name": "Group 8780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8779",
    "data-name": "Group 8779",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7996",
    "data-name": "Path 7996",
    d: "M289.816,311.455a7.08,7.08,0,0,1-1.209.707c-14.812,7.213-36.291-3.179-46.451-9.834a33.145,33.145,0,0,1-5.346-4.112c-3.851-4.222-9.137-32.827,8.536-27.5,1.827.567,5.844,3.533,10.105,6.831,2.09,1.668,4.264,3.391,6.247,5,3.834,3.037,9.087,6.6,9.74,6.546,3.255-.327,12.62-36.761,13.236-37.431,0,0,6.674,1.643,8.89,1.457.354-.019,6.528,51.5-3.749,58.34",
    transform: "translate(-17.661 -19.079)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7997",
    "data-name": "Path 7997",
    d: "M217.8,290.322c1.527,6.467,17.463,13.387,24.8,20.293,8.831-5.725,11.845-18.744,8.85-35.13-13.54-11.584-26.42-13.118-39.161-11.575-11.036,1.337,4.192,20.851,5.514,26.411",
    transform: "translate(-15.792 -19.97)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7998",
    "data-name": "Path 7998",
    d: "M292.579,231.741a14.841,14.841,0,0,0-2.205,5.251c-.136.213-.2.429-.311.641a6.751,6.751,0,0,0-.5-.549c-1.158-1.007-3.381-1.774-4.543-.324-1.226,1.532.668,3.308,1.476,4.524a13.45,13.45,0,0,1,2.149,4.671,22.587,22.587,0,0,1-.395,4.966c-.139,1.183-.635,3.058.272,4.082a6.242,6.242,0,0,0,3.637,1.429c1.348.072,2.27-.854,3.1-1.8a12.6,12.6,0,0,0,1.748-2.7,10.362,10.362,0,0,0,1.99-5.438,7.267,7.267,0,0,0-.116-1.27,9.87,9.87,0,0,0,2.162-4.976,1.2,1.2,0,0,0-1.335-1.361,2.246,2.246,0,0,0-.253-1.116,1.692,1.692,0,0,0-.982-.774,3.991,3.991,0,0,0-.4-1.109,3.253,3.253,0,0,0-3.053-1.74,15.787,15.787,0,0,1,4.863-3.386,1.289,1.289,0,0,0,.223-2.193c-2.336-2.045-6.193,1.278-7.529,3.173",
    transform: "translate(-21.578 -17.28)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7999",
    "data-name": "Path 7999",
    d: "M289.683,251.563s-1.261,4.974-1.926,7,7.144,1.646,7.144,1.646L296.967,255a34.344,34.344,0,0,1,.315-4.028c.28-1.786-4.728-4.658-5.114-3.362a19.259,19.259,0,0,1-2.486,3.957",
    transform: "translate(-21.812 -18.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8000",
    "data-name": "Path 8000",
    d: "M360.844,297.468,279.29,261.4a2.072,2.072,0,0,1-1.057-2.735l22.9-51.79a2.073,2.073,0,0,1,2.734-1.058l81.555,36.065a2.073,2.073,0,0,1,1.057,2.734l-22.9,51.791a2.073,2.073,0,0,1-2.735,1.057",
    transform: "translate(-21.08 -15.59)",
    fill: "#000a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8001",
    "data-name": "Path 8001",
    d: "M327.651,257.158c1.19,2.649,4.106,3.938,7.5,2.956l51.785-14.854a1.832,1.832,0,0,0,.36-3.392l-.035-.016L305.87,205.861l-.034-.015a1.833,1.833,0,0,0-2.27,2.547Z",
    transform: "translate(-22.999 -15.595)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8002",
    "data-name": "Path 8002",
    d: "M315.626,247.512a1.819,1.819,0,0,0,1.1-2.545l-15.176-30.736a1.818,1.818,0,0,0-3.294.069L280.2,255.133a1.819,1.819,0,0,0,2.192,2.476Z",
    transform: "translate(-21.231 -16.164)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8003",
    "data-name": "Path 8003",
    d: "M361.4,299.275,345.135,265a2.5,2.5,0,0,0-2.934-1.324l-8.516,2.437a8.587,8.587,0,0,1-10.087-4.463l-3.759-7.6a2.5,2.5,0,0,0-2.955-1.28L280.935,263.69c-.2.059-.382.111-.525.165-.486.2-.763.434-.782.719-.016.245.2.512.573.745l80.492,35.593a.957.957,0,0,0,.937-.076c.2-.205.185-.569,0-1.062-.055-.143-.14-.314-.23-.5",
    transform: "translate(-21.199 -19.155)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8004",
    "data-name": "Path 8004",
    d: "M386.975,252.534l-32.584,9.349a1.818,1.818,0,0,0-1.14,2.529l14.728,31.027a1.819,1.819,0,0,0,3.307-.044l17.854-40.377a1.818,1.818,0,0,0-2.164-2.483",
    transform: "translate(-26.767 -19.14)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8005",
    "data-name": "Path 8005",
    d: "M344.382,250.49c-5.329.8-12.72,4.216-14.373,9.985-.795,2.782,1,3.334,2.694,1.307,3.273-3.906,6.725-5.591,1.493-.063-1.058,1.119-2.688,3.939-1.852,4.727,1.774,1.673,5.015-2.795,6.7-4.552,2.012-.675-1.259,4.091-1.263,5.258-.027,5.274,6.286-3.452,7.048-3.291,2.127.446-3.066,5.664.415,5.295,2.609-.276,5.314-6.95,7.066-8.324,1.435-1.121,3.183-.9,3.368-3.009.4-4.7-9.047-7.67-11.3-7.332",
    transform: "translate(-25.004 -18.988)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8006",
    "data-name": "Path 8006",
    d: "M347.256,250.569c-1.931-.776-6.673-2.635-8.8-2.175-1.161.25-2.424,1.2-1.036,2.181a6.556,6.556,0,0,0,3.112.861c.9.073,1.854.414,2.747.416.91,0,4.236-1.184,3.978-1.284",
    transform: "translate(-25.534 -18.826)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8007",
    "data-name": "Path 8007",
    d: "M418.049,194.06q-.725,3.674-1.654,7.357c-.212,1-.48,1.97-.733,2.965-2.441,9.263-5.5,17.922-8.513,23.7a22.947,22.947,0,0,1-4.256,6.179c-11.931,10.927-33.987,15.787-44.294,17.569-3.507.591-5.653.819-5.653.819l-8.1-8.739s35.6-22.2,37.024-24.536c3.036-4.909,9.066-40.633,4-46.838-4.886-5.937,21.985-16.949,29.278-15.7,7.189,1.236,6.62,18.919,2.906,37.225",
    transform: "translate(-26.144 -11.883)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8008",
    "data-name": "Path 8008",
    d: "M387.349,176c-1.455-3.151-10.479-23.352-7.089-38.563,1.542-6.921,9.758-21.853,18.609-20.535,14.177,2.109,24.108,27.808,30.477,46.769-10.382,10.231-25.856,14.154-42,12.33",
    transform: "translate(-28.771 -8.856)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8009",
    "data-name": "Path 8009",
    d: "M346.975,250.185a9.586,9.586,0,0,1-3.588-.466c-1.62-.617-1.852,2.044-2.893,2.584s5.516,8.681,7.213,8.449a16.558,16.558,0,0,1,4.322.3s1.9-2.494,6.553-2.806-6.284-7.214-8.136-7.06a5.892,5.892,0,0,1-3.472-1",
    transform: "translate(-25.805 -18.925)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8010",
    "data-name": "Path 8010",
    d: "M139.842,309.115c18.289-22.048,38.612-10.669,43.791-4.4,47.117,56.994,117.8,68.421,124.787,103.975,3.781,19.235-12.473,67.42-109.957,68.107-101.735.717-125.49-58.144-102.244-95.762,23.219-37.576,25.32-49.85,43.624-71.916",
    transform: "translate(-6.673 -22.451)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8011",
    "data-name": "Path 8011",
    d: "M192.961,475.5v-.969c16.263,0,27.571-10.93,32.731-21.161,5.406-10.716,6.152-25.3-4.37-33.737-7.918-6.348-18.11-7.4-27.966-8.411-15.051-1.548-30.614-3.148-39-23.059-13.708-32.543,8.056-86.3,8.278-86.839l1.128.306c-.219.536-21.858,53.988-8.279,86.22,8.147,19.339,22.659,20.831,38.024,22.412,10.051,1.034,20.446,2.1,28.653,8.681,9.6,7.7,11.418,21.353,4.637,34.8-5.308,10.519-16.983,21.762-33.834,21.762",
    transform: "translate(-11.359 -22.844)",
    fill: "#000a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8012",
    "data-name": "Path 8012",
    d: "M276.541,462.278l-.407-.909c15.728-4.651,22.547-21.6,22.23-35.382-.275-11.891-5.732-25.947-20.219-29.735-10.191-2.664-17.634-2.756-24.829-2.844-12.758-.157-23.777-.292-44.77-15.523-32.245-23.394-32.528-74.837-32.527-75.355l1.19,0c0,.512.284,51.526,32.128,74.629,20.662,14.99,31.476,15.123,44,15.278,6.945.084,14.817.181,25.177,2.891,15.085,3.943,20.762,18.413,21.045,30.638.325,14.114-6.735,31.5-23.013,36.309",
    transform: "translate(-13.344 -22.936)",
    fill: "#000a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8013",
    "data-name": "Path 8013",
    d: "M174.931,476.9a127.575,127.575,0,0,1-25.35-4.945,100.021,100.021,0,0,1-22.964-10.117,61.841,61.841,0,0,1-17.529-15.752,50.024,50.024,0,0,1-8.824-20.011,54.214,54.214,0,0,1-1.039-10.636c-.06-1.779.081-3.555.156-5.331.178-1.772.3-3.547.6-5.308a96.229,96.229,0,0,1,5.52-20.78,159.869,159.869,0,0,1,9.24-19.868c3.566-6.46,7.511-12.772,11.7-18.969-4.021,6.272-7.79,12.65-11.171,19.157a160.081,160.081,0,0,0-8.9,19.894c-1.249,3.378-2.274,6.807-3.228,10.244a90.692,90.692,0,0,0-2.093,10.423c-.286,1.746-.395,3.5-.562,5.257-.065,1.758-.2,3.516-.128,5.272a53.89,53.89,0,0,0,1.075,10.49,49.122,49.122,0,0,0,8.579,19.716,62.3,62.3,0,0,0,17.156,15.613,99.067,99.067,0,0,0,22.616,10.267,126.54,126.54,0,0,0,25.143,5.384",
    transform: "translate(-7.521 -26.169)",
    fill: "#000a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8014",
    "data-name": "Path 8014",
    d: "M236.566,306.577l.628-6.178s6.514-9.145,1.751-16.882-17.651,3.329-17.651,3.329l5.149,13.694Z",
    transform: "translate(-16.777 -21.286)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8015",
    "data-name": "Path 8015",
    d: "M155.18,382.632c5.981,4.521,12.1,8.844,18.461,12.833,12.965,8.12,27.856,16.7,43.529,17.479,7.058.354,12.228-4.735,17.722-8.548q11.417-7.966,22.635-16.189c6.925-5.089,14.1-10.038,20.429-15.865,3.688-3.355,8.18-7.249,7.419-12.53,6.874-.649,5.536,3.468,12.461,5.2,1.681.434-4.462-11.824-6.166-12.259-13.482-3.356-14.525-.384-25.972,4.816-14.234,6.5-29.531,5.465-45.151,4.358-9.957-.708-19.973-1.814-29.989-2.655a1.1,1.1,0,0,0-1.083-.789,93.216,93.216,0,0,1-14.56.222c-3.7-.237-7.227-.65-10.642-1.165-1.18,2.507-7.419,16-9.094,25.091",
    transform: "translate(-11.765 -26.635)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8016",
    "data-name": "Path 8016",
    d: "M164.882,358.227c0,.164-.676,1.432-.651,1.566.867,9.04,13.481,10.856,20.356,10.991,2.895.079,5.818.053,8.715-.027,11.343,2.11,23.494,3.3,34.754.46a1.359,1.359,0,0,0,.242-2.6c-6.737-2.814-15.183-1.842-22.9-1.165a68.949,68.949,0,0,1-8.96-1.812c-6.008-1.679-11.721-4.169-17.811-5.549a28.463,28.463,0,0,1-3.031-.867c-4.629-.3-11.152-1.294-10.719-1",
    transform: "translate(-12.451 -27.154)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8017",
    "data-name": "Path 8017",
    d: "M251.165,355.073c-40.71,17.757-85.751-4.59-85.941-4.668.759-1.461,9.856-16.822,12.346-22.426a30.874,30.874,0,0,0,2.247-9.391,70.684,70.684,0,0,0-.055-14.456c-.162-1.758-.351-3.085-.433-3.706a.907.907,0,0,1-.053-.217c-3.275-16.3-10.393-35.621,8.525-41.576a38.543,38.543,0,0,1,8.284-1.569h.027a79.2,79.2,0,0,1,11.99-.082,114.37,114.37,0,0,1,12.343,5.334c2.247,1.136,4.628,2.434,6.9,3.87,6.822,4.276,8.31,12.856,8.064,18.7-.161,4.06-5.006,12.693-6.333,14.453,2.913,19.246,18.948,50.157,22.088,55.731",
    transform: "translate(-12.526 -19.468)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8018",
    "data-name": "Path 8018",
    d: "M215.587,250.311v7.634s2.052,3.764,0,4.176c-4.512.9-11.023-6.135-11.023-6.135V245.744Z",
    transform: "translate(-15.508 -18.63)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8019",
    "data-name": "Path 8019",
    d: "M204.572,249.863v-4.228s5.444,5.3,11.023,6.268c0,0-7.566,4.674-11.023-2.04",
    transform: "translate(-15.509 -18.622)",
    fill: "#fb987c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8020",
    "data-name": "Path 8020",
    d: "M216.018,223.4s5.322,9.877,7.23,17.375c1.353,5.323-7.7,13.628-16.665,6.967s-8.1-18.578-8.1-18.578Z",
    transform: "translate(-15.046 -16.936)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8021",
    "data-name": "Path 8021",
    d: "M183.287,223.335c.891-4.023,3.622-6.608,7.807-6.872a5.183,5.183,0,0,1,4.556,1.622,4.985,4.985,0,0,1,.953,2.682c4.941-3.829,26.831-10.779,24.415,8.044-5.256-6.069-14.552-3.242-16.778,2.253a15.011,15.011,0,0,0,.369,3.147c.635,3.252,1.22,6.077.053,9.323-1.525,4.249-5.449,4.968-7.792,2.173-1.6-1.915-3.428-5.987-4.5-10-1.928,1.609-4.956,2.172-7.083.785-3.707-2.421-2.795-9.583-2-13.161",
    transform: "translate(-13.841 -16.397)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8022",
    "data-name": "Path 8022",
    d: "M183.287,223.335c.891-4.023,3.622-6.608,7.807-6.872a5.183,5.183,0,0,1,4.556,1.622,4.985,4.985,0,0,1,.953,2.682c4.941-3.829,26.831-10.779,24.415,8.044-5.256-6.069-14.552-3.242-16.778,2.253a15.011,15.011,0,0,0,.369,3.147c.635,3.252,1.22,6.077.053,9.323-1.525,4.249-5.449,4.968-7.792,2.173-1.6-1.915-3.428-5.987-4.5-10-1.928,1.609-4.956,2.172-7.083.785C181.582,234.075,182.495,226.913,183.287,223.335Z",
    transform: "translate(-13.841 -16.397)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8023",
    "data-name": "Path 8023",
    d: "M207.061,236.463s-3.422-1.129-3.761,1.552,2.211,3.94,3.407,3.316,1.239-3.867.355-4.868",
    transform: "translate(-15.41 -17.909)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8024",
    "data-name": "Path 8024",
    d: "M221.03,303.261c-5.982,4.546-14.48,4.6-21.411,7.253-6.09,2.355-12.4,7.985-18.81,9.394a70.684,70.684,0,0,0-.055-14.456,26.281,26.281,0,0,0-.433-3.706c0-.082-3.857-10.176-.88-12.937,7.85-7.417,14.4-14.6,14.4-14.6a33.851,33.851,0,0,1-3.627,22.68c-1.38,2.464-2.98,4.669-1.575,9.043,0,.109.082.19.082.324-.19,2.977,14.8-3.186,16.989-3.754a45.7,45.7,0,0,1,14.807-1.705c1.245.082,1.38,1.813.513,2.464",
    transform: "translate(-13.518 -20.788)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8025",
    "data-name": "Path 8025",
    d: "M192.264,405.607c10.367,3.579,13.219-.693,24.206-.027,8.739.531,14.438-6.907,20.637-12.164,9.052-7.679,17.765-15.852,28.251-21.557,3.371-1.832,13.118-5.908,12.923-10.766-.228-5.551-8.21-.664-10.022.449-3.826,2.353-7.064,5.519-10.641,8.215-4.834,3.646-10.192-.907-15.746,1.467-9.767,4.172-20.035-.167-30.1,3.179-3.412,1.135-7.015-.158-10.615.172-2.453.227-4.792-.444-7.208-.584-2.517-.145-7.574-2.641-9.646-1.074-.457.346,1.565,21.265,1.823,21.77a4.684,4.684,0,0,0,.587.874c-.782.143-1.569.3-2.347.425-1.329.22,6.62,9.178,7.9,9.62",
    transform: "translate(-13.966 -27.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8026",
    "data-name": "Path 8026",
    d: "M192.264,405.607c10.367,3.579,13.219-.693,24.206-.027,8.739.531,14.438-6.907,20.637-12.164,9.052-7.679,17.765-15.852,28.251-21.557,3.371-1.832,13.118-5.908,12.923-10.766-.228-5.551-8.21-.664-10.022.449-3.826,2.353-7.064,5.519-10.641,8.215-4.834,3.646-10.192-.907-15.746,1.467-9.767,4.172-20.035-.167-30.1,3.179-3.412,1.135-7.015-.158-10.615.172-2.453.227-4.792-.444-7.208-.584-2.517-.145-7.574-2.641-9.646-1.074-.457.346,1.565,21.265,1.823,21.77a4.684,4.684,0,0,0,.587.874c-.782.143-1.569.3-2.347.425C183.033,396.207,190.982,405.165,192.264,405.607Z",
    transform: "translate(-13.966 -27.178)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8027",
    "data-name": "Path 8027",
    d: "M186.24,430.83a12.483,12.483,0,0,0,2.527-1.623,16.559,16.559,0,0,1,4.443-1.046,28.954,28.954,0,0,0,6.27-1.907c4.748-2.1,8.475-6.827,13.684-7.633a.714.714,0,0,0,.592-.484.759.759,0,0,0,.634-.689c.283-2.57-1.282-6.958-3.973-8-1.215-.47-2.878.25-4.041.425-3.523.534-6.43.008-9.851-.616-4.79-.872-8.11,2.167-12.807,2.046-2.54-.064-4.181.031-4.665,3.016-.584,3.587,1.462,17.449,7.187,16.512",
    transform: "translate(-13.567 -31.015)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8028",
    "data-name": "Path 8028",
    d: "M212.57,411.641c-.016,0,0,.017,0,.017a12.109,12.109,0,0,0,2.768,3.142c3.222,2.13,61.868-12.157,69.436-16.925,6.477-4.084,13.766-8.249,17.639-15.151a24.57,24.57,0,0,0,2.847-14.71,26.189,26.189,0,0,0-1.188-5.45c-1.806-5.419-3.415-8.607-9.453-10.072-6.77-1.644-15.264.928-21.5,3.481-8.1,3.352-15.3,8.479-21.9,14.158-6.915,5.94-36.144,27.884-42.166,34.814.521,3.164,1.409,3.875,3.516,6.7",
    transform: "translate(-15.849 -26.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8029",
    "data-name": "Path 8029",
    d: "M212.57,411.641c-.016,0,0,.017,0,.017a12.109,12.109,0,0,0,2.768,3.142c3.222,2.13,61.868-12.157,69.436-16.925,6.477-4.084,13.766-8.249,17.639-15.151a24.57,24.57,0,0,0,2.847-14.71,26.189,26.189,0,0,0-1.188-5.45c-1.806-5.419-3.415-8.607-9.453-10.072-6.77-1.644-15.264.928-21.5,3.481-8.1,3.352-15.3,8.479-21.9,14.158-6.915,5.94-36.144,27.884-42.166,34.814C209.575,408.11,210.463,408.821,212.57,411.641Z",
    transform: "translate(-15.849 -26.684)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8030",
    "data-name": "Path 8030",
    d: "M188,410.744c.018.007,3.683-.856,3.7-.849,2.822,1.394,3.505,4.887,2.545,8.412-.511,1.875-1.941,3.418-2.749,5.167a33.033,33.033,0,0,1-3.581,6.594c-.762,1-2.126-.257-1.452-1.251,3.411-5.021,2.627-11.009,1.418-16.6-.227-1.052-.385-2.174.119-1.469",
    transform: "translate(-14.122 -31.075)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8031",
    "data-name": "Path 8031",
    d: "M212.857,412.957c-.016,0,0,.017,0,.017a12.109,12.109,0,0,0,2.768,3.142c3.222,2.13,61.868-12.157,69.436-16.925,6.477-4.084,13.766-8.249,17.639-15.151a24.57,24.57,0,0,0,2.847-14.71,123.2,123.2,0,0,1-16.093,15.135c-8.1,6.1-17.658,9.812-27.207,13-8.171,2.717-16.5,4.163-24.948,5.725-7.209,1.351-14.533,3.045-20.9,6.835a14.1,14.1,0,0,0-3.547,2.929",
    transform: "translate(-16.137 -28)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8032",
    "data-name": "Path 8032",
    d: "M179.176,495.3c2.708-.783,2.346-2,1.578-3.846-1.419-3.416.557-6.282-1.605-9.659-1.542-2.409-2.849-4.462-3.32-7.113-.157-.877.068-2.2-.716-3.017-1.742-1.819-6.355-2.33-8.723-1.754-.375.091-.508.323-.482.563a.447.447,0,0,0-.3.5c.677,3.925-2.792,7.33-3.474,11.1a16.118,16.118,0,0,0-.075,4.859,9.449,9.449,0,0,1,.238,3.4c-.05.189-.926,1.587-.847,2.082.7,4.321,14.468,3.825,17.722,2.883",
    transform: "translate(-12.24 -35.608)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8033",
    "data-name": "Path 8033",
    d: "M179.056,490.092c-.007-.014,0-.024-.01-.035-.966-1.912-2.549-3.883-5.577-3.67-1.608.112-3.006.832-4.536,1.144a31.745,31.745,0,0,0-5.791,1.509c-.893.364.064,1.354.948,1.041,4.457-1.574,9.431-.427,14.038.94.87.257,1.481-.538.928-.929",
    transform: "translate(-12.341 -36.873)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8034",
    "data-name": "Path 8034",
    d: "M165.68,465.652a8.975,8.975,0,0,0,3.3,1.04s.022.007.015-.007a26.14,26.14,0,0,0,5.067.317c.944-.051,1.555-.191,1.629-.412,2.906-8.084,9.772-42.3,11.631-50.72a90.968,90.968,0,0,0,2.456-24.737c-.375-6.409-1.57-14.773-5.228-19.869a9.542,9.542,0,0,0-2.456-2.426c-2.98-2.014-6.638-1.786-10.208-1.218a19.439,19.439,0,0,0-4.432,1.285,20.788,20.788,0,0,0-9.765,8.65c-3.665,6.233-4.086,14.234-4.735,21.5-.76,8.5,9.986,64.74,12.722,66.6",
    transform: "translate(-11.593 -27.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8035",
    "data-name": "Path 8035",
    d: "M165.68,465.652a8.975,8.975,0,0,0,3.3,1.04s.022.007.015-.007a26.14,26.14,0,0,0,5.067.317c.944-.051,1.555-.191,1.629-.412,2.906-8.084,9.772-42.3,11.631-50.72a90.968,90.968,0,0,0,2.456-24.737c-.375-6.409-1.57-14.773-5.228-19.869a9.542,9.542,0,0,0-2.456-2.426c-2.98-2.014-6.638-1.786-10.208-1.218a19.439,19.439,0,0,0-4.432,1.285,20.788,20.788,0,0,0-9.765,8.65c-3.665,6.233-4.086,14.234-4.735,21.5C152.2,407.549,162.944,463.793,165.68,465.652Z",
    transform: "translate(-11.593 -27.84)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8036",
    "data-name": "Path 8036",
    d: "M175.792,467.133c.945-.052,1.556-.191,1.63-.413,2.906-8.083,9.772-42.3,11.631-50.719a90.971,90.971,0,0,0,2.456-24.738c-.376-6.408-1.571-14.772-5.229-19.869a9.557,9.557,0,0,0-2.456-2.426c.059.457,2.434,19.862.974,30.069-1.475,10.325-10.149,62.078-9.005,68.1",
    transform: "translate(-13.319 -27.972)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8037",
    "data-name": "Path 8037",
    d: "M190.4,233.434a32.2,32.2,0,0,0,5.145-13.212c.263-1.725,2.9-1.105,2.637.606a33.97,33.97,0,0,1-5.387,13.87c-.965,1.434-3.364.182-2.395-1.264",
    transform: "translate(-14.417 -16.618)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8038",
    "data-name": "Path 8038",
    d: "M183.334,261.933l1.794-1.077c.69-.414,11.151.391,11.151.391l.774,5.674.717,8.894-2.454,1.935s-.213-.808-.628-.207-2.239.853-2.239.853l-4.119-4.734s-3.533-5.41-3.754-5.8-1.242-5.934-1.242-5.934",
    transform: "translate(-13.899 -19.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8039",
    "data-name": "Path 8039",
    d: "M200.164,335.716S197,343.251,196.5,343.9c0,0-5.592.625-10.929.9-13.423.691-41.757-4.261-57.926-15.366-15.786-10.855,1.859-42.726,22.376-53.555.057-.067.157-.087.242-.145,16.26-8.626,18.266,22.027,15.264,23.217a24.37,24.37,0,0,0-3.69,2c-6.973,4.416-16.1,13.185-15.117,14.522.908,1.217,5.6,4.351,8.552,5.754a169.066,169.066,0,0,0,20.869,7.5c11.986,3.709,23.477,6.613,24.024,6.983",
    transform: "translate(-9.216 -20.788)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8040",
    "data-name": "Path 8040",
    d: "M164.272,303.114c2.77-1.1,20.995-8.962,27.857-20.434,3.124-5.219,9.287-17.492,3-21.892-10.071-7.053-31.42,3.09-46.571,11.137.428,12.5,4.593,22.8,15.716,31.189",
    transform: "translate(-11.262 -19.591)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8041",
    "data-name": "Path 8041",
    d: "M221.427,347.007a14.833,14.833,0,0,0-4.846-2.99,6.945,6.945,0,0,0-.586-.406,6.884,6.884,0,0,0,.619-.407c1.174-.988,2.275-3.066,1.022-4.439-1.323-1.448-3.371.148-4.7.759a13.445,13.445,0,0,1-4.948,1.4,22.593,22.593,0,0,1-4.845-1.158c-1.147-.32-2.923-1.1-4.074-.363a6.248,6.248,0,0,0-1.975,3.372c-.279,1.322.493,2.375,1.3,3.342a12.679,12.679,0,0,0,2.395,2.144,10.367,10.367,0,0,0,5.065,2.806,7.321,7.321,0,0,0,1.272.082,9.872,9.872,0,0,0,4.582,2.9,1.2,1.2,0,0,0,1.551-1.106,2.253,2.253,0,0,0,1.142-.079,1.689,1.689,0,0,0,.916-.85,3.965,3.965,0,0,0,1.159-.224,3.254,3.254,0,0,0,2.19-2.747,15.788,15.788,0,0,1,2.593,5.328,1.29,1.29,0,0,0,2.132.56c2.383-1.993-.3-6.317-1.969-7.93",
    transform: "translate(-14.938 -25.638)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8042",
    "data-name": "Path 8042",
    d: "M196.744,339.19l5.222,1.555v7.409a4.189,4.189,0,0,0-2.611-.211c-1.739.29-6.748-1.213-6.17-3.455s3.559-5.3,3.559-5.3",
    transform: "translate(-14.642 -25.715)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8043",
    "data-name": "Path 8043",
    d: "M206.4,235.562l.1,1.88A41.045,41.045,0,0,1,207.1,242c-.075.714,2.843,1.147,2.975.289s.143-4.693.143-4.693-.262-1.75-.7-1.759a9.759,9.759,0,0,1-1.616-.377Z",
    transform: "translate(-15.647 -17.851)",
    fill: "#ffc0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8044",
    "data-name": "Path 8044",
    d: "M214.96,355.1l-39.15,2.368,37.33,10.466Z",
    transform: "translate(-13.328 -26.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8045",
    "data-name": "Path 8045",
    d: "M214.96,355.1l-39.15,2.368,37.33,10.466Z",
    transform: "translate(-13.328 -26.921)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8782",
    "data-name": "Group 8782",
    transform: "translate(162.274 330.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8781",
    "data-name": "Group 8781",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2914",
    "data-name": "Rectangle 2914",
    width: 17.784,
    height: 38.524,
    transform: "translate(-1.067 15.1) rotate(-85.959)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8784",
    "data-name": "Group 8784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8783",
    "data-name": "Group 8783",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8047",
    "data-name": "Path 8047",
    d: "M296.922,363.7l-80.72,4.879.012,4.709L296.9,367.9Z",
    transform: "translate(-16.391 -27.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8048",
    "data-name": "Path 8048",
    d: "M296.922,363.7l-80.72,4.879.012,4.709L296.9,367.9Z",
    transform: "translate(-16.391 -27.573)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8786",
    "data-name": "Group 8786",
    transform: "translate(199.811 289.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8785",
    "data-name": "Group 8785",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2916",
    "data-name": "Rectangle 2916",
    width: 99.9,
    height: 80.239,
    transform: "translate(-17.899 7.315) rotate(-22.228)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8788",
    "data-name": "Group 8788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8787",
    "data-name": "Group 8787",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8050",
    "data-name": "Path 8050",
    d: "M439.843,355.659a13.69,13.69,0,0,0,7.785-2.567,66.462,66.462,0,0,1-1.157,14.3c-3.059,4.931-11.547,14-10.973,13.95a27.485,27.485,0,0,0,6.812-1.588,50.768,50.768,0,0,1-5.189,8.484c-4.117,5.491-9.984,9.882-12.213,16.585a.419.419,0,0,1-.256.294.485.485,0,0,1-.8.355c-11.076-10.516-13.056-26.494-14.683-40.9-.077-.683-.153-1.355-.217-2.041a44.405,44.405,0,0,0,10.21,7.968c.536.292-6.935-11.664-10.594-17.172a32.361,32.361,0,0,1,1.908-10.23c2.592-6.945,7.036-13.443,11.35-19.423.174-.247.374-.483.548-.729a33.138,33.138,0,0,0,4.765,8.633c.356.464-.785-8.743-1.486-12.947,1.084-1.344,2.165-2.688,3.292-3.987,1.479-1.741,3.3-4.694,5.952-4.3,2.574.364,8.437,10.9,9.181,13.917.321,1.286.608,2.6.871,3.92.127.565.229,1.145.332,1.713a158.789,158.789,0,0,1,1.975,16.041c-.183.285-.365.569-.573.846-2.151,2.926-7.364,8.869-6.834,8.872",
    transform: "translate(-30.974 -23.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8051",
    "data-name": "Path 8051",
    d: "M439.843,355.659a13.69,13.69,0,0,0,7.785-2.567,66.462,66.462,0,0,1-1.157,14.3c-3.059,4.931-11.547,14-10.973,13.95a27.485,27.485,0,0,0,6.812-1.588,50.768,50.768,0,0,1-5.189,8.484c-4.117,5.491-9.984,9.882-12.213,16.585a.419.419,0,0,1-.256.294.485.485,0,0,1-.8.355c-11.076-10.516-13.056-26.494-14.683-40.9-.077-.683-.153-1.355-.217-2.041a44.405,44.405,0,0,0,10.21,7.968c.536.292-6.935-11.664-10.594-17.172a32.361,32.361,0,0,1,1.908-10.23c2.592-6.945,7.036-13.443,11.35-19.423.174-.247.374-.483.548-.729a33.138,33.138,0,0,0,4.765,8.633c.356.464-.785-8.743-1.486-12.947,1.084-1.344,2.165-2.688,3.292-3.987,1.479-1.741,3.3-4.694,5.952-4.3,2.574.364,8.437,10.9,9.181,13.917.321,1.286.608,2.6.871,3.92.127.565.229,1.145.332,1.713a158.789,158.789,0,0,1,1.975,16.041c-.183.285-.365.569-.573.846C444.526,349.713,439.314,355.656,439.843,355.659Z",
    transform: "translate(-30.974 -23.526)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8790",
    "data-name": "Group 8790",
    transform: "translate(388.173 300.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8789",
    "data-name": "Group 8789",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2918",
    "data-name": "Rectangle 2918",
    width: 25.068,
    height: 133.673,
    transform: "translate(-0.213)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8792",
    "data-name": "Group 8792",
    transform: "translate(342.59 326.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8791",
    "data-name": "Group 8791",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2919",
    "data-name": "Rectangle 2919",
    width: 47.392,
    height: 68.599,
    transform: "translate(-0.222 0)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8794",
    "data-name": "Group 8794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8793",
    "data-name": "Group 8793",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8054",
    "data-name": "Path 8054",
    d: "M421.141,464.444c-1.86-14.183-4.707-28.143-9.555-41.5a.381.381,0,0,0,.03-.377q-.861-2.084-1.754-4.155-1.289-3.2-2.748-6.35a.478.478,0,0,0-.141-.177q-3.932-8.617-8.354-17a.559.559,0,0,0,.167-.219,27.456,27.456,0,0,0,2.16-9.832c.019-.661-1.1-.628-1.123.031a26.5,26.5,0,0,1-1.835,8.823q-1.353-2.544-2.744-5.068a.529.529,0,0,0,.313-.335,42.383,42.383,0,0,0,2.136-14.087c-.013-.656-1.137-.626-1.123.032a41.419,41.419,0,0,1-1.925,13.3q-6.431-11.51-13.778-22.536c-.362-.541-1.359.01-1,.554q5.552,8.307,10.563,16.917c-4.585,1.023-8.884-.2-13.05-1.467a.53.53,0,0,0-.346,1c4.448,1.357,9,2.578,13.885,1.4.018,0,.029-.015.044-.019q8.207,14.133,14.983,28.984A17.149,17.149,0,0,1,399.918,410c-.57-.363-1.171.548-.6.908a17.944,17.944,0,0,0,6.569,2.519.594.594,0,0,0,.492-.129q1.049,2.323,2.063,4.661c6.118,14.9,9.483,30.64,11.587,46.669.372-.062.744-.127,1.116-.186",
    transform: "translate(-28.557 -27.654)",
    fill: "#000a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8055",
    "data-name": "Path 8055",
    d: "M380.885,376.12a28.689,28.689,0,0,1-9.738-3.8c.056.466.138.935.216,1.4a30.091,30.091,0,0,0,9.17,3.407c.7.131,1.042-.863.352-1",
    transform: "translate(-28.137 -28.226)",
    fill: "#000a3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8796",
    "data-name": "Group 8796",
    transform: "translate(400.291 349.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8795",
    "data-name": "Group 8795",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2921",
    "data-name": "Rectangle 2921",
    width: 58.716,
    height: 50.779,
    transform: "translate(-0.608 0)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8798",
    "data-name": "Group 8798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8797",
    "data-name": "Group 8797",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8057",
    "data-name": "Path 8057",
    d: "M451.4,398.429c-8.854,8.737-11.6,24.79-12.172,29.35a20.653,20.653,0,0,0-1.823,5.928c-1.054,7.2-.744,14.806-.565,22.065.059,2.388.165,4.773.291,7.158.41-.077.82-.153,1.23-.227-.078-1.505-.149-3.011-.2-4.517-.221-6.5-.213-13.014.084-19.51a28.666,28.666,0,0,1,1.767-9.844,1.354,1.354,0,0,0,.394-.366c5.51-7.661,11.016-15.678,17.4-22.626,5.418-5.894,12.569-8.63,19.892-11.342,3.309-1.225,13.733-3.407,13.8-7.914-13.888,1.62-29.9,1.786-40.1,11.844",
    transform: "translate(-33.104 -29.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8058",
    "data-name": "Path 8058",
    d: "M451.4,398.429c-8.854,8.737-11.6,24.79-12.172,29.35a20.653,20.653,0,0,0-1.823,5.928c-1.054,7.2-.744,14.806-.565,22.065.059,2.388.165,4.773.291,7.158.41-.077.82-.153,1.23-.227-.078-1.505-.149-3.011-.2-4.517-.221-6.5-.213-13.014.084-19.51a28.666,28.666,0,0,1,1.767-9.844,1.354,1.354,0,0,0,.394-.366c5.51-7.661,11.016-15.678,17.4-22.626,5.418-5.894,12.569-8.63,19.892-11.342,3.309-1.225,13.733-3.407,13.8-7.914C477.611,388.205,461.594,388.371,451.4,398.429Z",
    transform: "translate(-33.104 -29.308)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8059",
    "data-name": "Path 8059",
    d: "M452.082,393.936a28.9,28.9,0,0,1-.189-10.059q-.5.281-.981.562a29.558,29.558,0,0,0,.277,9.7c.113.579,1,.37.893-.2",
    transform: "translate(-34.164 -29.103)",
    fill: "#000a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8060",
    "data-name": "Path 8060",
    d: "M448.356,395.969a38.1,38.1,0,0,1-1.293-8.963c-.3.216-.593.45-.885.685a38.682,38.682,0,0,0,1.285,8.488c.151.563,1.043.362.894-.21",
    transform: "translate(-33.826 -29.34)",
    fill: "#000a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8061",
    "data-name": "Path 8061",
    d: "M459.23,460.8a32.427,32.427,0,0,1-13.444,26.331H407.648a32.521,32.521,0,0,1-12.658-33.418,31.711,31.711,0,0,1,1.789-5.608h59.875a31.8,31.8,0,0,1,1.795,5.608,32.31,32.31,0,0,1,.781,7.087",
    transform: "translate(-29.886 -33.972)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8062",
    "data-name": "Path 8062",
    d: "M460.333,460.8a32.427,32.427,0,0,1-13.444,26.331H408.75c49.83,2.473,49.007-39.026,49.007-39.026a31.8,31.8,0,0,1,1.795,5.608,32.31,32.31,0,0,1,.781,7.087",
    transform: "translate(-30.988 -33.972)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8063",
    "data-name": "Path 8063",
    d: "M119.941,199.606A5.575,5.575,0,1,1,114.4,194a5.575,5.575,0,0,1,5.543,5.605",
    transform: "translate(-8.248 -14.708)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8064",
    "data-name": "Path 8064",
    d: "M130.907,175.813l-.1,18.359-34.78-.194.1-18.359a17.39,17.39,0,0,1,34.78.194",
    transform: "translate(-7.28 -12.003)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8065",
    "data-name": "Path 8065",
    d: "M114.462,169.027a6.45,6.45,0,0,1-6.407-6.48l.037-6.676a6.444,6.444,0,0,1,12.887.072l-.037,6.676a6.451,6.451,0,0,1-6.479,6.408m.1-17.08a3.963,3.963,0,0,0-3.981,3.937l-.038,6.676a3.96,3.96,0,0,0,7.919.044l.037-6.676a3.963,3.963,0,0,0-3.937-3.981",
    transform: "translate(-8.192 -11.331)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8066",
    "data-name": "Path 8066",
    d: "M146.92,195.709a1.061,1.061,0,0,1-.864-1.676c9.792-13.734.1-27.618,0-27.756a1.061,1.061,0,0,1,1.727-1.234c.107.152,10.661,15.268,0,30.221a1.06,1.06,0,0,1-.865.445",
    transform: "translate(-11.058 -12.479)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8067",
    "data-name": "Path 8067",
    d: "M159.69,211.536a1.06,1.06,0,0,1-.863-1.676c21.954-30.8.223-61.925,0-62.237a1.061,1.061,0,1,1,1.726-1.234,62.4,62.4,0,0,1,8.661,20.193,53.453,53.453,0,0,1-8.661,44.51,1.062,1.062,0,0,1-.865.445",
    transform: "translate(-12.026 -11.064)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8068",
    "data-name": "Path 8068",
    d: "M82.323,195.709a1.06,1.06,0,0,1-.865-.445c-10.66-14.953-.106-30.069,0-30.221a1.061,1.061,0,0,1,1.728,1.233c-.4.567-9.77,14.054,0,27.757a1.061,1.061,0,0,1-.864,1.676",
    transform: "translate(-5.815 -12.479)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8069",
    "data-name": "Path 8069",
    d: "M69.1,211.536a1.062,1.062,0,0,1-.865-.445,53.453,53.453,0,0,1-8.661-44.51,62.4,62.4,0,0,1,8.661-20.193,1.061,1.061,0,1,1,1.726,1.234,61.514,61.514,0,0,0-8.342,19.526c-3.655,15.448-.848,29.818,8.343,42.71a1.06,1.06,0,0,1-.863,1.676",
    transform: "translate(-4.397 -11.064)",
    fill: "#858d9e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    x2: 13.737,
    transform: "translate(493.991 453.776)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    x2: 5.416,
    transform: "translate(482.258 453.776)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    x2: 474.495,
    transform: "translate(3.852 453.776)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/No_Notification.dffc59edc45c5ab344baf276e7e01c89.svg";
export { ForwardRef as ReactComponent };